module.exports = __webpack_public_path__ + "static/media/tire-rugged.0ff76f94.svg";